/**
 * Componente que inicializa o DRE Store na montagem da aplicação
 * Garante que dados master estejam sempre disponíveis
 */

import { useEffect } from 'react';
import { useDREStore } from '../stores/dreStore';

export function DREStoreInitializer() {
  const loadMasterVersion = useDREStore(state => state.loadMasterVersion);
  const loadDRE = useDREStore(state => state.loadDRE);

  useEffect(() => {
    console.log('[DREStoreInitializer] 🚀 Inicializando DRE Store...');
    
    // Carregar master data (sempre disponível offline)
    loadMasterVersion()
      .then(() => {
        console.log('[DREStoreInitializer] ✅ Master data carregada');
      })
      .catch(error => {
        console.error('[DREStoreInitializer] ❌ Erro ao carregar master:', error);
      });

    // Carregar DRE editável (pode falhar se offline)
    loadDRE()
      .then(() => {
        console.log('[DREStoreInitializer] ✅ DRE editável carregada');
      })
      .catch(_error => {
        console.warn('[DREStoreInitializer] ⚠️ DRE editável não disponível (usando master)');
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Executar apenas uma vez na montagem

  // Este componente não renderiza nada
  return null;
}
